import { breakpointUp, screenSizeCoefficient } from '../utils/breakpoints'

let $popup = $('.game-popup')
let $body = $('body')
let $html = $('html')


function openGamePopup()
{
    $('.game-popup .popup-content-container').animate({
      scrollTop : 0
    }, 10);

    $popup.addClass('popup-visible')
    $html.addClass('popup-open')

    if(breakpointUp('sm')) {

      let wheelBlock = $('.wheel-spinner')

      if(wheelBlock.height() > wheelBlock.width()) {
        wheelBlock.addClass('is-vertical')
        wheelBlock.parent().css('max-height', wheelBlock.width() + 'px')
      }

      let remSize = screenSizeCoefficient() * 32
      let wheelHalf = ($("#game-wheel").width() / remSize) + ($('.wheel-arrow').width() / remSize) + 1

      $('.wheel-arrow').css('transform', 'translateX(' + Math.ceil(wheelHalf) + 'rem)')

    }

}

function closeGamePopup()
{
  if($popup.hasClass('popup-visible')) {
    $popup.removeClass('popup-visible')
    $html.removeClass('popup-open')
  }

}

$body.on('click', '.js-open-game-wheel', function (e){
  e.preventDefault()
  openGamePopup()

})

$body.on('click', '.game-popup .js-close-popup, .game-popup .js-background-popup', function (e){
  e.preventDefault()
  closeGamePopup()
})

$(document).keyup(function(e) {
  if (e.key === "Escape" && $popup.is(':visible')) { // escape key maps to keycode `27`
    closeGamePopup()
  }
});

export { openGamePopup }
